export default __webpack_public_path__ + "static/media/pin_2.191f4551.png";